<template>
  <b-row v-if="!loading">
    <!-- COLUMNA1 -->

    <b-col md="4">
      <b-card no-body class="card-custom  myUser mb-5" v-if="myUser">
        <b-card-body>
          <div class="d-grid grid-profile border-bottom pb-3">
            <div class="image">
              <img
                src="/media/svg/avatars/001-boy.svg"
                alt=""
                v-if="!myUser.avatar"
                class="w-100"
              />
              <img :src="getPhoto(myUser)" alt="" v-else class="w-100" />
            </div>
            <div class="info text-right">
              <h4
                class="font-weight-bolder text-dark-75  mb-0 text-hover-primary"
              >
                {{ myUser.firstName }} {{ myUser.lastName }}
              </h4>
              <div class="text-muted pb-4">{{ myUser.userName }}</div>

              <div class="level" v-if="myLevel && myUser.points">
                <span class="text-dark-50 font-weight-bold">
                  Level {{ myLevel.lvl }}
                </span>
                <span class="label label-inline label-dark">
                  {{ myLevel.name }}
                </span>
              </div>
              <div
                class="font-weight-bolder font-size-h4 mt-2"
                v-if="myUser.points.total"
              >
                {{ myUser.points.total.toFixed(0) }}
              </div>
              <div class="font-weight-bolder font-size-h4 mt-2" v-else>
                0
              </div>
            </div>
          </div>
          <profiles-user :user="myUser" class="pt-2"></profiles-user>
        </b-card-body>
      </b-card>
      <b-card no-body class="card-custom  myUser mb-5" v-if="myUser">
        <b-card-body>
          <div class="font-weight-bolder font-size-h4 mb-4">
            Deadlines Log
          </div>
          <div class="deadlines d-flex justify-content-between">
            <div v-for="d in deadlines" :key="d.title" class="text-center">
              <h3>#{{ d.title }}</h3>
              <div
                v-if="
                  myUser.deadlines.filter((c) => c.deadline == d._id).length
                "
              >
                <div
                  v-b-tooltip.hover
                  :title="
                    myUser.deadlines.filter((c) => c.deadline == d._id)[0]
                      .score + ' points'
                  "
                >
                  <div
                    v-if="
                      myUser.deadlines.filter((c) => c.deadline == d._id)[0]
                        .level == 'lvl2'
                    "
                  >
                    <span
                      class="svg-icon svg-icon-3x svg-icon-success d-block my-2"
                    >
                      <i class="fas font-size-h1 fa-award text-success"></i>
                    </span>
                  </div>
                  <div
                    v-else-if="
                      myUser.deadlines.filter((c) => c.deadline == d._id)[0]
                        .level == 'lvl1'
                    "
                  >
                    <span
                      class="svg-icon svg-icon-3x svg-icon-success d-block my-2"
                    >
                      <i class="fas font-size-h1 fa-check text-warning"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span
                      class="svg-icon svg-icon-3x svg-icon-danger d-block my-2"
                    >
                      <i
                        class="fas font-size-h1 fa-skull-crossbones text-dark"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
                  <i class="fas font-size-h1 fa-lock text-light-secondary"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="mt-5 ">
            <p>
              X
              <i class="fas  fa-award text-success"></i>
              represent X play rounds
            </p>
            <p>
              2
              <i class="fas  fa-skull-crossbones text-dark"></i>
              in a row and you are <strong>OUT!</strong>
            </p>
            <p>
              3
              <i class="fas  fa-skull-crossbones text-dark"></i>
              and you are <strong>OUT!</strong>
            </p>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col md="4">
      <b-card class="card-custom mb-5 paths" no-body v-if="limitedPath">
        <b-card-body class="card-body">
          <div class="timeline timeline-3">
            <div class="timeline-items">
              <Timeline :path="limitedPath" :index="1"></Timeline>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <!-- <b-col md="4">
   <b-card class="card-custom mb-5" no-body v-if="team">
        <b-card-body>
          <router-link :to="'/teams/'">
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-3"
            >
              <div class="logo">
                <img
                  :src="'https://api.xupxup.net/' + team.logo"
                  class="align-self-center"
                  style="width:100px"
                  alt
                />
              </div>
              <div class="">
                <h4 class="font-weight-bolder text-dark-75 text-right">
                  {{ team.name }}
                </h4>

            
                <div
                  class="font-weight-bolder font-size-h4 text-success text-right"
                >
                  {{ puntsTeam }}
                </div>
              </div>
            </div>
          </router-link>
          <profiles-team class="pt-1"></profiles-team>
        </b-card-body>
      </b-card>
    </b-col> -->
    <b-col md="4" v-if="limitedPath">
      <challenge-path :path="limitedPath" :extended="false"></challenge-path>
    </b-col>

    <b-col md="5">
      <b-card class="card-custom " no-body>
        <b-card-body class="">
          <div class="font-weight-bolder font-size-h4 mb-4">
            My projects
          </div>
          <ActiveProjects :user="myUser._id" />
        </b-card-body>
      </b-card>
    </b-col>
    <b-col md="7">
      <b-card class=" card-custom sessions" no-body>
        <b-card-body>
          <div class="font-weight-bolder font-size-h4 mb-8">Sessions</div>
          <b-list-group>
            <b-list-group-item v-for="s in sessions" :key="s._id"
              ><div class="d-grid grid-sessions">
                <div class="date font-weight-bolder">
                  {{
                    paths.find((p) => p._id == s.path).startDate
                      | moment("D MMM YYYY")
                  }}
                </div>
                <span class="assistance">
                  <i
                    class="fas fa-hand-spock text-dark "
                    :class="{ 'opacity-20': !s.assistance }"
                  ></i>
                </span>
                <span class="training">
                  <i
                    class="fas fa-graduation-cap text-dark"
                    :class="{ 'opacity-20': !isChallengeDone(s.path) }"
                  ></i>
                </span>
                <div class="title">
                  {{ paths.find((p) => p._id == s.path).title }}
                </div>
                <div class="points d-flex justify-content-end">
                  <div
                    v-b-tooltip.hover
                    :title="p.name"
                    class=" rounded-sm  px-2 py-1 mr-2"
                    v-for="p in profiles"
                    :key="p._id"
                    :style="'background-color:' + bgColor(p.color) + ';'"
                  >
                    <i
                      class="fas"
                      :class="p.image"
                      :style="'color:' + p.color"
                    ></i>

                    <span
                      :style="'color:' + p.color"
                      class="ml-1  font-size-lg font-weight-bolder"
                      >{{
                        s.points.find((point) => point.profile == p._id).points
                      }}</span
                    >
                  </div>
                </div>
                <div
                  v-b-toggle="'comment-' + s._id"
                  class="ml-5 comments bg-warning text-center rounded-sm py-1 text-light-warning"
                  :class="{ 'bg-light-dark ': !s.description }"
                >
                  <b-icon-chat v-if="!s.description"></b-icon-chat>
                  <b-icon-chat-dots v-else></b-icon-chat-dots>
                </div>
              </div>
              <b-collapse :id="'comment-' + s._id">
                <div class="comment" v-if="s.description">
                  {{ s.description }}
                </div>
              </b-collapse>
            </b-list-group-item>
          </b-list-group>
        </b-card-body>
      </b-card>
    </b-col>

    <!-- COLUMNA2 -->
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ActiveProjects from "@/view/layout/dashboard/ActiveProjects";
import Timeline from "@/view/layout/dashboard/Timeline";
import "@/core/plugins/collapse";
import ProfilesUser from "../layout/dashboard/ProfilesUser.vue";
//import ProfilesTeam from "../layout/dashboard/ProfilesTeam.vue";
import ChallengePath from "../layout/dashboard/ChallengePath.vue";

export default {
  name: "dashboard",
  components: {
    ActiveProjects,
    Timeline,
    ProfilesUser,
    // ProfilesTeam,
    ChallengePath,
  },
  data() {
    return {
      levelUserName: "",
      levelUser: 0,
      puntsequip: 0,
      disseny: 0,
      // levels: [],
      development: 0,
    };
  },
  beforeCreate() {
    // this.levels = this.$store.getters.getLevels;
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  },
  computed: {
    deadlines() {
      return this.$store.getters.getDeadlines;
    },
    loading() {
      return this.$store.state.api.loading;
    },
    myUser() {
      return this.$store.getters.getMyUser;
    },
    team() {
      return this.$store.getters.getMyTeam;
    },
    puntsTeam() {
      let total = 0;

      this.team.users.forEach(function(u) {
        total += u.points.total;
      });
      return total;
    },

    profiles() {
      return this.$store.getters.getProfiles;
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    myLevel() {
      console.log(this.myUser);
      let points = 0;
      console.log(this.myUser.points);
      if (this.myUser.points) {
        points = this.myUser.points.total > 0 ? this.myUser.points.total : 0;
      }
      return this.levels.find((l) => l.points <= points);
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    paths() {
      return this.$store.getters.getPaths;
    },
    limitedPath() {
      let today = new Date();
      let day = today.getDay();
      let myDay = this.myUser.group == "B" ? 0 : 3;
      let week = 0;
      if (day > myDay) {
        week = today.weekNumber;
      } else {
        week = today.weekNumber + 1;
      }
      return this.paths.find(
        (p) => p?.startDate.weekNumber == week && p.isActive === true
      );
    },
    sessions() {
      return this.$store.getters.getMySessions;
    },

    ...mapGetters(["currentUser"]),
  },
  methods: {
    getPhoto(user) {
      return user?.avatar
        ? process.env.VUE_APP_API_URL + user.avatar
        : "/media/svg/avatars/001-boy.svg";
    },
    isChallengeDone(path) {
      let challenge = this.paths.find((p) => p._id == path).challenge;
      if (this.myUser.challenges.includes(challenge)) {
        return true;
      } else {
        return false;
      }
    },
    bgColor(i) {
      let color = i.split("1)");

      return color[0] + "0.3)";
    },
    // calculatePoints(inst) {
    // 	let total = 0;
    // 	for (let i = 0; i < inst.project.sections.length; i++) {
    // 		total += inst.project.sections[i].points.reduce((accum, s) => accum + s.points, 0);
    // 	}
    // 	return total;
    // }
  },
};
</script>

<style scoped>
a.non-decoration {
  color: #3f4254;
}
.image img {
  width: 100%;
  border-radius: 20px;
}
.path {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  margin-bottom: 5px;
  padding: 10px 15px 15px;
  background-color: rgba(255, 255, 255, 0.8);
}

.path .symbol {
  padding-left: 25px;
}

.path .symbol-label {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
